import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-icon-aluminium-extrusion',
    templateUrl: './icon-aluminium-extrusion.component.html'
})
export class IconAluminiumExtrusionComponent implements OnInit {

    @Input() cssClass = 'icon--18';

    constructor() { }

    ngOnInit() {
    }

}
